import { render, staticRenderFns } from "./AccountantProfileWidget.vue?vue&type=template&id=e025a56c&"
import script from "./AccountantProfileWidget.vue?vue&type=script&lang=js&"
export * from "./AccountantProfileWidget.vue?vue&type=script&lang=js&"
import style0 from "./AccountantProfileWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports